import React from 'react'
import { styled, useTheme } from 'src/ui/theme'
import { Image } from 'src/ui/atoms'
import { Col } from 'src/ui/layout'
import { Label, Header, Body } from 'src/ui/typography'
import { breakpoints } from 'src/ui/dimensions'

const Title = styled.div`
  display: grid;

  grid-template-columns: 50% 50%;

  @media (max-width: ${breakpoints.desktop}px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }
`

const InfoBlock = styled.div`
  width: 100%;
  height: 751px;
  padding: 64px;
  background-color: #f1f1f8;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
`

const StyledLabel = styled(Label)`
  font-weight: 900;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
`

const StatsBlock = styled.div`
  padding: 24px 0;
  display: flex;
`

const StatsItem = styled.div`
  padding: 0 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  &:first-child {
    padding-left: 0;
  }
`

const StyledBody = styled(Body)`
  line-height: 150%;
`

type Props = {
  images: TImages
}

export const Podcast = ({ images }: Props) => {
  const theme = useTheme()
  return (
    <Title>
      <Col>
        <InfoBlock>
          <StyledLabel>качаем софтскиллы вместе с подкастом KODE</StyledLabel>
          <Header as="h2" size="h2">
            «Вдруг тут что-то <br /> важное»
          </Header>
          <StyledBody weight="regular">
            В 2024 году мы запустили подкаст о том, как строить и развивать
            карьеру в IT. Мы хотели создать полезный, доступный и вдохновляющий
            продукт для всех русскоговорящих  IT-специалистов. Нам было важно не
            просто рассказывать истории топов бигтеха, а создать среду для
            обмена опытом, который каждый слушатель может применить в реальной
            жизни. <br /> <br /> За 3 сезона подкаста к нам пришли технические
            директора, продуктовые менеджеры и архитекторы из топовых компаний
            России — Авито, ТБанк, Skillbox, и другие
          </StyledBody>

          <StatsBlock>
            <StatsItem>
              <Header size="h2" as="h2" color={theme.colors.brand.primary}>
                1500+
              </Header>
              <Header size="h5" as="h5" color={theme.colors.black.primary}>
                подписчиков
              </Header>
            </StatsItem>
            <StatsItem>
              <Header size="h2" as="h2" color={theme.colors.brand.primary}>
                10000+
              </Header>
              <Header size="h5" as="h5" color={theme.colors.black.primary}>
                прослушиваний
              </Header>
            </StatsItem>
          </StatsBlock>
          <Body weight="medium">
            <a href="https://kode.mave.digital/" target="_blank">
              Слушать подкаст по ссылке →
            </a>
          </Body>
        </InfoBlock>
      </Col>
      <Col>
        <Image height={751} fluid={images['podcast']} />
      </Col>
    </Title>
  )
}
